import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LegalBlock } from './types/legal-block.type';

@Component({
  selector: 'jb-legal-block',
  templateUrl: './dynamic-jb-legal-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicJbLegalBlockComponent {
  @Input('content') legalBlockContent: LegalBlock[];
}

export const jbLegalBlockComponentResolver = (registry, data) => ({
  legalBlockContent: data.legalBlock,
});
